// ─────────────────────────────────────────────────────────────────────────────
// i18n/locales/fr.ts – Français
// ─────────────────────────────────────────────────────────────────────────────
export default {
  lang: { de: 'Deutsch', fr: 'Français', it: 'Italiano', en: 'English', es: 'Español', pt: 'Português' },

  nav: {
    // Menuepunkt der Uebersichtsseite (T-M41.3) — eigener Schluessel neben
    // `nav.dashboard`, das zwei andere Stellen beschriftet.
    overview:     'Vue d\'ensemble',
    dashboard:    'Tableau de bord',
    jobs:         'Travaux d\'impression',
    fleet:        'Flotte',
    printers:     'Imprimantes',
    schankanlage: 'Système de boissons',
    printserver:  'Serveur d\'impression',
    settings:     'Paramètres',
    users:        'Utilisateurs',
    company:      'Entreprise',
    locations:    'Sites',
    smtp:         'E-mail SMTP',
    api:          'API',
    switchCompany:'Changer d\'entreprise',
    selectCompany:'Sélectionner une entreprise',
    logout:       'Déconnexion',
  },

  common: {
    save:          'Enregistrer',
    saving:        'Enregistrement en cours …',
    cancel:        'Annuler',
    delete:        'Supprimer',
    deleting:      'Suppression en cours …',
    edit:          'Modifier',
    add:           'Ajouter',
    back:          'Retour',
    loading:       'Chargement en cours …',
    search:        'Rechercher …',
    yes:           'Oui',
    no:            'Non',
    confirm:       'Confirmer',
    confirmDelete: 'Vraiment supprimer ?',
    cannotUndo:    'Cette action est irréversible.',
    new:           'Nouveau',
    optional:      '(optionnel)',
    unknown:       '—',
    active:        'Actif',
    inactive:      'Inactif',
    enabled:       'Activé',
    disabled:      'Désactivé',
    seconds:       'sec.',
    minutes:       'min.',
    noData:        'Aucune donnée disponible.',
    close:         'Fermer',
    remove:        'Retirer',
    copy:          'Copier',
    copied:        'Copié !',
    change:        'Modifier',
    send:          'Envoyer',
    sending:       'Envoi en cours …',
    processing:    'Traitement en cours …',
    show:          'Afficher',
    hide:          'Masquer',
    yesDelete:     'Oui, supprimer',
    yesRemove:     'Oui, retirer',
    note:          'Remarque',
    error:         'Erreur',
    version:       'Version',
    // Kennzahl, die NICHT serverseitig gezaehlt ist: Untergrenze (REQ-OPS-034)
    count: {
      atLeast:      'Au moins {count}',
      atLeastShort: '≥ {count}',
      atLeastHint:  'Déduit de la liste chargée – au moins autant, peut-être davantage.',
    },
    // Blaettern statt Kuerzen (REQ-OPS-032/033, T-M8.19b) — die zwei Texte,
    // die in JEDER geblaetterten Liste gleich lauten.
    pagination: {
      liveFirstPageOnly: 'Seule la première page est actualisée en continu.',
      loadFailed:        'Le chargement a échoué.',
    },
  },

  status: {
    online:   'En ligne',
    offline:  'Hors ligne',
    printing: 'Impression',
    error:    'Erreur',
    ready:    'Prêt',
    pending:  'En attente',
    done:     'Terminé',
    // Statut de livraison `completed` (REQ-DM-040) — voir de.ts.
    completed: 'Livré',
    failed:   'Échoué',
    expired:  'Expiré',
  },

  role: {
    admin:    'Administrateur',
    user:     'Utilisateur',
  },

  auth: {
    email:               'Adresse e-mail',
    password:            'Mot de passe',
    passwordNew:         'Nouveau mot de passe',
    passwordNewLabel:    'Nouveau mot de passe *',
    passwordConfirm:     'Confirmer le mot de passe',
    passwordConfirmLabel:'Confirmer le mot de passe *',
    passwordMinHint:     'Au moins 8 caractères',
    passwordRepeat:      'Répéter le mot de passe',
    passwordMismatch:    'Les mots de passe ne correspondent pas.',
    passwordTooWeak:     'Le mot de passe est trop faible (au moins 8 caractères).',
    passwordSave:        'Enregistrer le mot de passe',
    passwordSaved:       'Mot de passe enregistré !',
    passwordSavedHint:   'Votre mot de passe a été modifié avec succès. Vous allez être redirigé automatiquement …',
    toDashboard:         'Aller au tableau de bord',
    linkInvalid:         'Lien invalide',
    linkInvalidHint:     'Ce lien a expiré ou a déjà été utilisé. Veuillez en demander un nouveau.',
    toLogin:             'Vers la connexion',
    setNewPassword:      'Définir un nouveau mot de passe',
    setNewPasswordHint:  'Entrez votre nouveau mot de passe pour',
    welcomeBack:         'Bon retour',
    welcomeHint:         'Connectez-vous avec votre compte.',
    login:               'Connexion',
    loggingIn:           'Connexion en cours …',
    logout:              'Déconnexion',
    forgotPassword:      'Mot de passe oublié ?',
    resetPassword:       'Réinitialiser le mot de passe',
    resetSent:           'E-mail envoyé. Veuillez vérifier votre boîte de réception.',
    backToLogin:         'Retour à la connexion',
    sessionExpired:      'Votre session a expiré (12 heures). Veuillez vous reconnecter.',
    footer:              'Payfix AG · Système de gestion d\'impression · v1.0',
    strength: {
      weak:      'Faible',
      medium:    'Moyen',
      strong:    'Fort',
      veryStrong:'Très fort',
    },
    errors: {
      invalidEmail:    'Adresse e-mail invalide.',
      wrongPassword:   'Mot de passe incorrect.',
      userNotFound:    'Aucun utilisateur trouvé avec cet e-mail.',
      tooManyRequests: 'Trop de tentatives. Veuillez patienter.',
      generic:         'Échec de la connexion. Veuillez réessayer.',
      occurred:        'Une erreur s\'est produite.',
    },
  },

  invitation: {
    title:        'Accepter l\'invitation',
    subtitle:     'Définissez votre mot de passe pour créer votre compte.',
    submit:       'Créer le compte',
    working:      'Création du compte …',
    successTitle: 'Votre compte est prêt',
    successHint:  'Vous allez être connecté et redirigé …',
    errInvalid:   'Cette invitation n\'est pas valide. Veuillez demander une nouvelle invitation.',
    errExpired:   'Cette invitation a expiré. Veuillez demander une nouvelle invitation.',
    errExists:    'Un compte existe déjà pour cette adresse. Veuillez vous connecter avec votre mot de passe actuel.',
    errFailed:    'L\'invitation n\'a pas pu être acceptée. Rien n\'a été créé ; veuillez réessayer.',
  },

  bootstrap: {
    errorTitle: 'Le démarrage a échoué',
    errorHint:  'La connexion n\'a pas pu être établie. Veuillez réessayer ou vous reconnecter.',
    errorHintNoProfile: 'Aucun profil utilisateur n\'existe pour ce compte. Veuillez contacter votre administrateur.',
    errorCode:  'Code d\'erreur : {code}',
    retry:      'Réessayer',
    reLogin:    'Se reconnecter',
  },

  // T-M21.5 / REQ-OPS-054 : l'avis NOMME les domaines concernés et n'affiche
  // AUCUN horodatage — l'heure de la dernière mise à jour reçue n'est nulle
  // part enregistrée.
  liveVerbindung: {
    title:     'Actualisation en direct interrompue',
    areas:     'Plus en direct : {areas}',
    hint:      'Les données affichées proviennent de la dernière actualisation reçue et peuvent être obsolètes. Elles ne seront actualisées à nouveau qu\'une fois la connexion rétablie.',
    reconnect: 'Se reconnecter',
    quiet:     'Connexion interrompue : {areas}',
    area: {
      jobs:         'Travaux d\'impression',
      printers:     'Imprimantes',
      printservers: 'Serveurs d\'impression',
      companies:    'Entreprises',
      locations:    'Sites',
      registers:    'Caisses',
      users:        'Utilisateurs',
      apiTokens:    'Tokens API',
    },
  },

  fleet: {
    title:          'Flotte',
    subtitle:       'Serveurs d\'impression par site – état, version et files en direct.',
    empty:          'Aucun serveur d\'impression',
    emptyHint:      'Dès qu\'un serveur d\'impression est configuré, il apparaît ici.',
    noLocation:     'Sans site',
    noServers:      'Aucun serveur d\'impression sur ce site',
    noPrinters:     'Aucune imprimante',
    unassignedPrinters: {
      text:   'Une imprimante attend une attribution | {count} imprimantes attendent une attribution',
      hint:   'Ces imprimantes ont été créées via l\'interface et n\'ont aucun serveur d\'impression attribué. Elles n\'apparaissent dans aucun groupe de cette vue et n\'accepteront des travaux qu\'une fois un serveur d\'impression attribué.',
      action: 'Attribuer dans la liste des imprimantes',
    },
    locationOffline:'Site hors ligne',
    serverCount:    '{n} serveurs d\'impression',
    version:        'Version',
    versionUnknown: 'Inconnue',
    versionOutlier: 'Écart',
    versionOutlierHint: 'Diffère de la version de la flotte v{version}.',
    lastPing:       'Dernier signe de vie',
    pending:        '{n} en attente',
    queueEmpty:     'Aucun travail en attente',
    pendingAtLeast: 'Au moins {n} en attente',
    queueUnknown:   'File d\'attente inconnue',
    queueUnknownHint: 'La file d\'attente n\'a pas pu être comptée. Cela ne signifie pas qu\'elle est vide.',
    queueHeldHeading: 'Retenus ({n})',
    queueHeldHint:    'Ces travaux ne sont imprimés qu\'au moment où la cuisine les met sur « Prêt à emporter ». Ils n\'ont donc pas de position dans la file d\'attente.',
    queueNoneWaiting: 'Rien n\'attend l\'imprimante',
    time: {
      never:        'Jamais',
      justNow:      'À l\'instant',
      minutes:      'Il y a {n} min',
      hours:        'Il y a {n} h',
      days:         'Il y a {n} jours',
    },
  },

  dashboard: {
    title:          'Tableau de bord',
    welcome:        'Bienvenue',
    totalJobs:      'Total des travaux',
    totalPrinters:  'Total des imprimantes',
    onlinePrinters: 'Imprimantes en ligne',
    printservers:   'Serveurs d\'impression',
    recentJobs:     'Derniers travaux d\'impression',
    noJobs:         'Aucun travail d\'impression disponible.',
    heldJobs:       'Retenus',
    heldJobsHint:   'Ces bons de commande ne sont imprimés qu\'au moment où la cuisine les met sur « Prêt à emporter ». Ils n\'attendent pas l\'imprimante et ne constituent pas un engorgement.',
  },

  printers: {
    title:         'Imprimantes',
    subtitle:      'Toutes les imprimantes connectées de cette entreprise',
    add:           'Ajouter une imprimante',
    empty:         'Aucune imprimante créée',
    emptyHint:     'Ajoutez la première imprimante de cette entreprise.',
    number:        'N°',
    name:          'Désignation',
    type:          'Type',
    printserver:   'Serveur d\'impression',
    ipAddress:     'Adresse IP',
    pendingBons:   'Bons en attente',
    deleteTitle:   'Supprimer l\'imprimante ?',
    deleteConfirm: 'Voulez-vous vraiment supprimer {name} ?',
    new:           'Nouvelle imprimante',
    edit:          'Modifier',
    openKitchen:      'Ouvrir Kitchen TV',
    openAbholscreen:  'Ouvrir l\'écran de retrait',
    openFastline:     'Ouvrir Fastline',
    // BERICHTIGT AM 2026-08-17 (T-M8.19b, REQ-OPS-032 neu gefasst): der
    // Schluessel bleibt, sein Wortlaut wird berichtigt statt geloescht. Bis
    // dahin sagte er „die Liste ist gekuerzt, weitere Drucker sind hier nicht
    // sichtbar" — eine Sackgasse. Die 100 sind ab jetzt die SEITENgroesse.
    limitReached:     'Il existe d\'autres imprimantes de cette entreprise : une page de {count} entrées est chargée — en charger d\'autres.',
    loadMore:         'Charger {count} imprimantes de plus',
    // Kurzform fuer das Nachladen IM Auswahlkontext (Drucker-Dropdown der
    // Auftragsliste): dort ist kein Platz fuer die Seitengroesse.
    loadMoreShort:    'Charger d\'autres imprimantes …',
    loadedCount:      '{count} imprimantes chargées',
    endOfList:        'Fin de la liste – toutes les imprimantes sont chargées.',
    sections: {
      basic:       'Données de base',
      abholscreen: 'Paramètres de l\'écran de retrait',
      kitchenTv:   'Paramètres Kitchen TV',
      alarm:       'Alertes',
      status:      'État',
      screenAccess: 'Clé d’affichage',
    },
    fields: {
      outputType:        'Type de sortie',
      outputPrint:       'Imprimante',
      outputKitchenTv:   'Kitchen TV / Écran',
      outputPrintHint:   'Imprimante ESC/POS physique avec adresse et type de modèle.',
      outputKitchenTvHint: 'Canal écran sans serveur d\'impression, adresse ou type de modèle.',
      port:              'Port',
      abholscreenEnabled: 'Écran de retrait activé',
      abholscreenEnabledHint: 'Affiche les numéros de commande prêts sur l\'écran de retrait.',
      displayDurationHint: 'Durée d\'affichage des commandes prêtes, de 5 à 600 secondes (par défaut 60 secondes).',
      autoCompleteDisabled:     'Désactiver la clôture automatique',
      autoCompleteDisabledHint: 'Les commandes prêtes restent affichées jusqu\'à leur clôture manuelle — la durée d\'affichage ne les clôture plus. Quatre heures après leur arrivée, elles sont malgré tout clôturées automatiquement ; ce nettoyage ne peut pas être désactivé.',
      maxItems:          'Numéros affichés max.',
      maxItemsUnit:      'numéros',
      maxItemsHint:      'Limite des numéros affichés simultanément (0 = illimité).',
      screenKeyHint:       'La clé d’affichage connecte un écran (Kitchen TV, écran de retrait, Fastline). Seul le hachage est enregistré; le texte en clair n’est plus récupérable ensuite.',
      screenKeySaveFirst:  'Veuillez d’abord enregistrer le canal, puis vous pourrez définir une clé d’affichage.',
      screenKeySet:        'Clé d’affichage définie',
      screenKeyNotSet:     'Aucune clé d’affichage',
      screenKeyPlaceholder:'Saisir ou générer une clé',
      screenKeyGenerate:   'Générer',
      screenKeySave:       'Définir la clé',
      screenKeyRotate:     'Renouveler la clé',
      screenKeyOnce:       'Cette clé n’est affichée qu’UNE seule fois. Notez-la maintenant en lieu sûr.',
      screenKeyRequired:        'Exiger la clé d’affichage',
      screenKeyRequiredHint:    'Un écran se connecte à ce canal avec la clé d’affichage. Sans elle, il n’obtient aucun accès.',
      screenKeyRequiredOffHint: 'Ce canal est ouvert sans clé d’affichage: qui connaît l’adresse de l’écran lit les commandes de ce canal et modifie leur statut de traitement. L’accès reste limité à ce canal et à cette entreprise.',
      screenKeyRequiredOffPrintHint: 'Sur ce canal, cela déclenche aussi une impression: passer une commande sur «Prête à être retirée» libère le bon de travail retenu, et il est imprimé.',
      alarmEnabled:      'Alertes activées',
      alarmEnabledHint:  'Notifie en cas de problème d\'imprimante (hors ligne, erreur).',
      alarmMuted:        'Couper complètement',
      alarmMutedHint:    'Supprime toutes les alertes de cette imprimante.',
      alarmStages:       'Niveaux d\'alerte',
      stage_offline:     'Hors ligne',
      stage_paperLow:    'Papier presque vide',
      stage_error:       'Erreur',
      stage_coverOpen:   'Capot ouvert',
      // Stufe Papierende (T-M42.3, REQ-PS-023c) und Kennzeichnung unwirksamer
      // Stufen je Modelltyp (REQ-PS-023a Praez. 1 (a) / Praez. 3).
      stage_paperOut:    'Plus de papier',
      stageIneffective:  'sans effet',
      stageIneffectiveTitle: 'Le type de modèle {model} ne signale pas cet état. Le niveau peut être activé, mais ne déclenche jamais d\'alerte sur cette imprimante.',
      stagesIneffectiveHint: 'Les niveaux marqués « sans effet » ne sont pas signalés par le type de modèle {model} : ils peuvent être activés, mais ne déclenchent jamais d\'alerte sur cette imprimante.',
      // T-M42.10 Teil (b): die gesetzten Stufen wuerden mangels Einrichtung
      // am Mandanten nie versendet (Regel: utils/alarmEinrichtung.ts).
      alarmNotSetUpTypeDisabled: 'Alarmes non configurées : « Panne d\'imprimante » est désactivé dans le centre d\'alarmes de l\'entreprise. Les niveaux définis ici ne sont jamais envoyés.',
      alarmNotSetUpNoRecipients: 'Alarmes non configurées : aucun destinataire n\'est défini dans le centre d\'alarmes de l\'entreprise. Les niveaux définis ici ne sont jamais envoyés.',
      printerId:         'ID imprimante',
      printerIdPlaceholder: 'p. ex. 3324',
      printerIdHint:     'L\'identifiant d\'imprimante du portail Payfix — exactement la valeur que la caisse envoie comme printer_id. Pas un numéro choisi librement : sans le bon identifiant, aucun ticket n\'atteint ce canal.',
      designation:       'Désignation',
      printerType:       'Type d\'imprimante',
      printerServer:     'Serveur d\'impression',
      ipAddress:         'Adresse IP',
      sameAddressHint:   'Même adresse que «{name}». Les deux canaux impriment l\'un après l\'autre sur le même appareil.',
      company:           'Entreprise',
      range:             'De / À',
      rangeFrom:         'De',
      rangeTo:           'À',
      tableRangesHint:   'Si des plages sont définies, ce canal ne reçoit que les bons de préparation et les reçus dont le numéro de table se trouve dans l\'une des plages. Cela vaut aussi pour le Kitchen TV, l\'écran de retrait et Fastline. Les documents sans numéro de table – notamment les clôtures journalières et les décomptes du personnel – parviennent toujours à ce canal. Si aucune plage n\'est définie, il reçoit tout.',
      qrCode:            'Imprimer le QR code',
      qrCodeHint:        'Ajoute un QR code sur le bon. Il est aussi la condition pour que les commandes apparaissent sur l\'écran de retrait de cette imprimante.',
      qrCodeOffByKitchenTv: 'Le QR code sur le bon reste désactivé tant que la vue Kitchen TV est activée — les deux ne sont jamais actifs en même temps sur la même imprimante. L\'activer ici désactive la vue Kitchen TV.',
      qrCodeOffByU220: 'Le TM-U220 n\'imprime pas de QR code. Sur ce modèle, l\'interrupteur est verrouillé et sans effet.',
      showName:          'Afficher le nom de l\'imprimante',
      colorWorking:      'Couleur en cours de traitement',
      colorReady:        'Couleur prêt à retirer',
      displayDuration:   'Durée d\'affichage',
      preview:           'Aperçu',
      kitchenTvEnabled:  'Kitchen TV',
      kitchenTvEnabledHint: 'Affiche en plus les commandes de cette imprimante sur un écran Kitchen TV. L\'imprimante reste une imprimante à part entière et continue d\'imprimer. L\'activation désactive le QR code sur le bon.',
      autoStartTimer:    'Démarrer le minuteur automatiquement',
      autoStartTimerHint:'Démarre le minuteur automatiquement à la réception d\'une commande',
      disablePrintingWhenKitchenTv:     'Ne pas imprimer les bons de préparation',
      disablePrintingWhenKitchenTvHint: 'Les bons de préparation de ce canal ne sont plus imprimés, ils sont uniquement affichés sur le Kitchen TV. Ils sont immédiatement considérés comme livrés et apparaissent dans la liste des travaux avec la mention « livré sans impression ». Les tickets de caisse restent imprimés. Sur un canal purement écran, le réglage reste sans effet, car rien n\'y est jamais imprimé.',
      fastline:          'Fastline',
      rangeRemove:       'Supprimer la plage {n}',
      abholscreenUrl:    'URL de l\'écran de retrait',
      kitchenTvUrl:      'URL Kitchen TV',
      kitchenTvUrlLight: 'URL Kitchen TV Light',
      fastlineUrl:       'URL Fastline',
    },
    // Der aktive Bildschirm-Modus, angezeigt statt eingestellt
    // (REQ-SC-106 (2), T-M25.5). Die drei Modusnamen sind Produktnamen und
    // stehen in allen sechs Sprachen gleich; die Feldwerte bleiben
    // technisch-englisch (REQ-OV-002, REQ-DM-068 (1)).
    screenMode: {
      label:    'Mode actif',
      hint:     'Indique quel écran pilote actuellement ce canal. Le mode est repris sur l\'écran lui-même, pas ici : celui qui ouvre l\'une des trois adresses y confirme le changement et désactive ainsi le mode précédent.',
      mode_normal:   'Kitchen TV normal',
      mode_light:    'Kitchen TV Light',
      mode_fastline: 'Fastline',
      mode_none:     'aucun mode actif',
    },
    kitchenTvInactive: 'Kitchen TV est désactivé. Activez-le ci-dessus pour accéder aux paramètres.',
    kitchenTvAlwaysOn: 'Ce canal est un canal d\'écran : la vue Kitchen TV y fonctionne toujours et ne peut pas être désactivée.',
    // Druckerzustand: grob (status.*) plus feine Kennungen (REQ-PS-020a/021).
    // Werte bleiben technisch-englisch in Firestore, hier nur die Anzeige.
    status: {
      title:       'État actuel',
      noDetail:    'Aucune anomalie',
      updatedAt:     'État inchangé depuis',
      updatedAtHint: 'L\'heure du dernier CHANGEMENT d\'état — et non celle du dernier signalement. Le serveur d\'impression n\'écrit cette valeur que lorsque l\'état change; une imprimante durablement saine affiche donc ici une heure ancienne.',
      never:         'Aucun état signalé',
      stale: {
        withAge:    'Obsolète — dernier signalement il y a {age}',
        unknownAge: 'Obsolète — âge inconnu',
        age: {
          lessThanMinute: 'moins d\'une minute',
          minute:  'une minute',
          minutes: '{n} minutes',
          hour:    'une heure',
          hours:   '{n} heures',
          day:     'un jour',
          days:    '{n} jours',
        },
        reason: {
          noPrintserver: 'Aucun serveur d\'impression n\'est attribué à cette imprimante. Seul le serveur d\'impression écrit l\'état — sans lui, la dernière valeur écrite reste affichée indéfiniment.',
          noPing:        'Le serveur d\'impression responsable n\'a encore écrit aucun signal de vie. Impossible donc de dire quel âge a l\'état affiché.',
          serverOffline: 'Le serveur d\'impression responsable est hors ligne. Il ne peut plus signaler l\'état de cette imprimante; la valeur affichée est la dernière écrite.',
          pingTooOld:    'Le dernier signal de vie du serveur d\'impression responsable dépasse le délai de 90 secondes (trois fois l\'intervalle de 30 secondes). L\'état affiché est le dernier écrit et peut ne plus être exact.',
        },
      },
      sourceLabel: 'Source',
      levelLabel:  'Niveau de détail',
      levelHint:   'Niveau de détail que ce modèle d\'imprimante peut fournir.',
      detail: {
        offline:     'Injoignable',
        coverOpen:   'Capot ouvert',
        paperOut:    'Plus de papier',
        cutterError: 'Erreur du massicot',
        error:       'Erreur d\'imprimante',
        notResponding: 'Ne répond pas',
        paperLow:    'Papier presque vide',
      },
      source: {
        asb:        'Signalé par l\'imprimante',
        poll:       'Interrogation active',
        jobResult:  'Déduit du résultat d\'impression',
        connection: 'Connexion interrompue',
      },
      level: {
        full:  'Complet',
        basic: 'Limité',
        none:  'Aucun retour d\'état',
      },
    },
    archived:     'Archivée',
    archivedHint: 'Les imprimantes archivées n\'acceptent plus de travaux.',
    incomplete:     'Incomplète',
    // Corrigé le 2026-09-07 (T-M33.3, REQ-DM-072 (h)) : depuis T-M8.3, les
    // travaux destinés à une imprimante sans serveur d'impression sont refusés
    // avec 400 — ils ne sont pas acceptés puis laissés sans distribution.
    incompleteHint: 'Cette imprimante n\'a pas de serveur d\'impression cible. Elle n\'accepte des travaux qu\'une fois un serveur d\'impression attribué ; jusque-là, les travaux qui lui sont envoyés sont refusés.',
    filter: {
      all:            'Toutes',
      unassigned:     'Sans serveur d\'impression ({count})',
      noneUnassigned: 'Chaque imprimante dispose d\'un serveur d\'impression.',
    },
    quickAssign: {
      label:       'Attribuer un serveur d\'impression',
      placeholder: 'Attribuer un serveur d\'impression …',
      saving:      'Attribution en cours …',
      failed:      'L\'attribution n\'a pas pu être enregistrée. Veuillez réessayer.',
      noServers:   'Aucun serveur d\'impression n\'est enregistré pour cette entreprise.',
    },
    unassignedNotice: {
      title: 'Aucun serveur d\'impression attribué',
      body:  'Cette imprimante a été créée via l\'interface et n\'accepte des travaux qu\'une fois un serveur d\'impression attribué. Sélectionnez un serveur d\'impression ci-dessous et enregistrez.',
    },
    validation: {
      nameRequired:         'Veuillez saisir une désignation.',
      numberRequired:       'Veuillez saisir l\'identifiant d\'imprimante du portail Payfix.',
      // NOUVEAU 2026-09-18 (T-M41.8, REQ-DM-036 Praez. 4 (ix)).
      payfixPrinterIdInvalid: 'Cet ID imprimante ne peut pas être enregistré. La barre oblique, les valeurs «.» et «..», les identifiants de la forme «__…__» ainsi que plus de 1500 octets ne sont pas admis. Veuillez saisir l\'identifiant enregistré pour cette imprimante dans le portail Payfix.',
      payfixPrinterIdTaken: 'L\'ID imprimante {id} est déjà attribué à l\'imprimante «{name}» de l\'entreprise «{company}». Chaque identifiant ne peut exister qu\'une seule fois — sinon le ticket arrive sur le mauvais canal. Veuillez saisir l\'identifiant enregistré pour cette imprimante dans le portail Payfix.',
      payfixPrinterIdTakenOtherCompany: 'L\'ID imprimante {id} est déjà attribué à l\'imprimante «{name}» de l\'entreprise «{company}» — donc en dehors de l\'entreprise sélectionnée ici, et cette imprimante ne vous est pas visible. Chaque identifiant ne peut exister qu\'une seule fois — sinon le ticket arrive sur le mauvais canal. Veuillez contacter les responsables de «{company}» ou saisir l\'identifiant enregistré pour cette imprimante dans le portail Payfix.',
      payfixPrinterIdTakenOtherCompanyUnnamed: 'L\'ID imprimante {id} est déjà attribué dans une autre entreprise. Laquelle ne peut pas être affichée ici — elle se situe en dehors de votre accès. Chaque identifiant ne peut exister qu\'une seule fois — sinon le ticket arrive sur le mauvais canal. Veuillez contacter le support Payfix ou saisir l\'identifiant enregistré pour cette imprimante dans le portail Payfix.',
      payfixPrinterIdTakenOrphaned: 'L\'ID imprimante {id} est déjà attribué à l\'imprimante «{name}», et cette imprimante n\'est rattachée à aucune entreprise lisible — un identifiant orphelin. Il reste donc occupé dans tout le système bien qu\'aucune entreprise ne puisse être trouvée. Veuillez saisir un autre identifiant enregistré dans le portail Payfix et signaler l\'identifiant orphelin à l\'exploitation.',
      payfixPrinterIdTakenOrphanedUnnamed: 'L\'ID imprimante {id} est déjà attribué, et l\'imprimante qui l\'occupe n\'est rattachée à aucune entreprise lisible — un identifiant orphelin. Il reste donc occupé dans tout le système bien qu\'aucune entreprise ne puisse être trouvée. Veuillez saisir un autre identifiant enregistré dans le portail Payfix et signaler l\'identifiant orphelin à l\'exploitation.',
      payfixPrinterIdCheckFailed: 'L\'ID imprimante n\'a pas pu être vérifié — le service de vérification est actuellement injoignable. Rien n\'a été enregistré. Veuillez réessayer dans un instant.',
      printserverRequired:  'Veuillez sélectionner un serveur d\'impression. Sans serveur cible, le travail n\'est pas distribué.',
      modelTypeRequired:    'Veuillez sélectionner un type de modèle (Standard, U220 ou Sunmi).',
      ipAddressRequired:    'Veuillez saisir l\'adresse IP ou le nom d\'hôte de l\'imprimante. Sans adresse, le serveur d\'impression ne peut ni la piloter ni interroger son état.',
      printserverForbidden: 'Un canal d\'écran ne doit pas avoir de serveur d\'impression.',
    },
    warnings: {
      abholscreenNeedsQrCode:       'L\'écran de retrait reste vide sur cette imprimante : sans impression du QR sur le bon, aucune commande n\'y apparaît. Le QR imprimé sur le bon est la preuve de retrait du client. Activer l\'impression du QR plus tard n\'agit que sur les nouvelles commandes — les commandes déjà créées n\'apparaissent pas rétroactivement.',
      abholscreenNeedsQrCodeAction: 'Activer l\'impression du QR sur le bon',
      abholscreenNeedsKitchenTvAction: 'Activer la vue Kitchen TV',
      abholscreenNeedsQrCodeSave:   'Écran de retrait actif, impression du QR sur le bon désactivée : cet écran de retrait reste vide. Cliquez de nouveau sur Enregistrer pour conserver ce réglage malgré tout.',
    },
    notices: {
      displayDurationDisabled:     'Sans effet : la clôture automatique est désactivée',
      displayDurationDisabledHint: 'Tant que la clôture automatique est désactivée, rien n\'expire au terme de cette durée. La valeur reste enregistrée et agit de nouveau dès que la clôture automatique est réactivée.',
    },
  },

  printserver: {
    title:              'Serveur d\'impression',
    subtitle:           'Serveurs d\'impression connectés de cette entreprise',
    subtitleAllCompanies: 'Serveurs d\'impression connectés de toutes les entreprises',
    subtitleOwnCompanies: 'Serveurs d\'impression connectés de vos entreprises',
    add:                'Ajouter un serveur d\'impression',
    empty:              'Aucun serveur d\'impression créé',
    emptyHint:          'Ajoutez le premier serveur d\'impression.',
    name:               'Nom',
    uuid:               'UUID',
    uuidCopy:           'Copier l\'UUID',
    uuidLabel:          'UUID (généré automatiquement)',
    uuidHint:           'Une désignation pour les personnes, pas une valeur de configuration : le daemon ne lit pas l\'UUID. Pour la configuration, c\'est l\'ID de document qui compte.',
    documentId:         'ID de document',
    documentIdHint:     'Le daemon lit cet identifiant comme PRINTSERVER_ID dans son fichier .env. Il est attribué à la création et ne peut pas être modifié.',
    documentIdPending:  'L\'identifiant est créé lors de l\'enregistrement.',
    ipAddress:          'Adresse IP',
    anydeskId:          'ID AnyDesk',
    anydeskIdMissing:   'Le serveur d\'impression transmet l\'identifiant AnyDesk au démarrage. S\'il manque, soit l\'appareil exécute encore un logiciel plus ancien qui ne le transmet pas, soit AnyDesk n\'y est pas installé ou l\'identifiant n\'est pas lisible.',
    company:            'Entreprise',
    status:             'Statut',
    connectedSince:     'Connecté depuis',
    lastContact:        'Dernier contact',
    connectedMins:      '{n} min. connecté',
    connectedHrs:       '{h} h {m} min. connecté',
    lessThan1Min:       '< 1 min.',
    lastContactSec:     'il y a {n} sec.',
    lastContactMin:     'il y a {n} min.',
    lastContactHr:      'il y a {n} h',
    nodeVersion:        'Version Node.js',
    appVersion:         'Version de l\'application',
    printerCount:       'Imprimantes connectées',
    printerCountValue:  '{n}',
    printerCountAtLeast:'au moins {n}',
    printerCountAtLeastHint: 'La liste des imprimantes n\'est chargée que page par page ({count} par page) — ce nombre est une limite inférieure. D\'autres imprimantes peuvent appartenir à ce serveur d\'impression ; en charger d\'autres.',
    printerCountUnknownHint: 'La liste des imprimantes n\'est pas encore disponible. Le nombre apparaît dès qu\'elle est chargée.',
    runtimeFieldPending:'Le serveur d\'impression transmet ce champ lors d\'un changement de statut (démarrage ou arrêt). Les appareils avec un logiciel plus ancien ne le transmettent pas encore — la valeur apparaît après le prochain redémarrage.',
    updateAvailable:    'Mise à jour disponible : v{v}',
    restartControl:     'Contrôle du redémarrage',
    restartManual:      'Redémarrage manuel',
    restartHint:        'Envoie une commande de redémarrage à l\'application Node.js sur le Raspberry Pi.',
    restartAfter:       'Redémarrage après (minutes)',
    restartNow:         'Redémarrer maintenant',
    restarting:         'Redémarrage …',
    // ⚠ `restartSent` ist am 2026-09-18 mit T-M41.9 in allen sechs Sprachen
    // ENTFALLEN; die Begründung steht am selben Ort in `de.ts`.
    // NOUVEAU 2026-09-18 (T-M41.9) : l'accusé de réception du document en direct
    // remplace le message de succès après le clic — deux horodatages, aucun verdict.
    restartRequested:        'Redémarrage demandé le {t}',
    restartNotAcknowledged:  'Pas encore d\'accusé de réception de l\'appareil.',
    restartExecuted:         'Exécuté par l\'appareil le {t}',
    restartReconnected:      'Reconnecté depuis {t}',
    autoRestartDelayHint: 'La modification prend effet au prochain démarrage du launcher sur l\'appareil — comme l\'heure de redémarrage. 0 = aucun intervalle.',
    autoRestart:        'Redémarrage automatique',
    autoRestartHint:    'L\'application redémarre automatiquement après cet intervalle. 0 = désactivé.',
    autoRestartDisabled:'Le redémarrage automatique est désactivé.',
    autoRestartEnabled: 'L\'application redémarre toutes les {n} minutes.',
    connectionInfo:     'Informations de connexion',
    connectionHint:     'Le Raspberry Pi met à jour l\'IP, la version et le statut automatiquement via le heartbeat Firestore.',
    deleteTitle:        'Supprimer le serveur d\'impression ?',
    deleteConfirm:      'Voulez-vous vraiment supprimer {name} ?',
    cannotUndoFull:     'Voulez-vous vraiment supprimer « {name} » ? Cette action est irréversible.',
    new:                'Nouveau serveur d\'impression',
    stammdaten:         'Données de base',
    assignCompany:      'Associer une entreprise',
    noCompany:          '— Aucune entreprise associée —',
    companyHint:        'Le serveur d\'impression n\'apparaît que pour les utilisateurs de cette entreprise.',
    companyPreset:      'Prédéfini',
    companySearch:      'Rechercher une entreprise …',
    companySelect:      'Sélectionner une entreprise',
    companyNoMatch:     'Aucune entreprise trouvée.',
    cascadeTitle:       'Des imprimantes perdent leur serveur d\'impression',
    cascadeText:        'Imprimantes associées à ce serveur d\'impression ({count}) : {names}. Elles perdent cette association et n\'acceptent plus de travaux tant qu\'aucun serveur d\'impression ne leur est attribué.',
    cascadeConfirm:     'Retirer l\'association et continuer',
    companyRequired:    'Veuillez associer une entreprise. Si le serveur d\'impression ne doit plus appartenir à aucune entreprise, supprimez-le.',
    infoCard:           'Info',
    piSetup:            'Configuration Raspberry Pi',
    piSetupHint:        'Saisissez cet identifiant dans le fichier .env du daemon Raspberry Pi :',
    piSetupPending:     'Enregistrez d\'abord le serveur d\'impression. L\'identifiant destiné au fichier .env du daemon Raspberry Pi apparaîtra ensuite ici.',
    settingsTitle:      'Tous les serveurs d\'impression configurés – cliquez pour ouvrir',
    settingsNoCompany:  '— Aucune entreprise —',
    settingsAddFirst:   'Créer le premier serveur d\'impression',
    location:           'Site',
    noLocation:         '— Aucun site associé —',
    locationHint:       'Associe le serveur d\'impression à un site.',
  },

  locations: {
    title:            'Sites',
    subtitle:         'Tous les sites de cette entreprise',
    add:              'Ajouter un site',
    empty:            'Aucun site créé pour le moment',
    emptyHint:        'Ajoutez le premier site de cette entreprise.',
    name:             'Nom du site',
    namePlaceholder:  'p. ex. Site principal Zurich',
    new:              'Nouveau site',
    edit:             'Modifier',
    autoUpdate:       'Mise à jour automatique',
    autoUpdateOn:     'Actif',
    paused:           'En pause',
    updateSection:    'Mise à jour automatique',
    updatePaused:     'Suspendre la mise à jour',
    updatePausedHint: 'Suspend la mise à jour automatique des serveurs d\'impression de ce site.',
    updateChannel:    'Canal de mise à jour',
    channelStable:    'Stable',
    channelBeta:      'Bêta',
    pinnedVersion:    'Version fixée',
    pinnedVersionHint:'Laisser vide pour la dernière version du canal choisi.',
    latest:           'Dernière',
    deleteTitle:      'Supprimer le site ?',
    deleteConfirm:    'Voulez-vous vraiment supprimer {name} ?',
  },

  jobs: {
    title:          'Travaux d\'impression',
    subtitle:       'Tous les travaux d\'impression de cette entreprise',
    new:            'Nouveau travail',
    empty:          'Aucun travail d\'impression disponible.',
    emptyFiltered:     'Aucun des travaux chargés ne correspond aux filtres définis.',
    emptyFilteredHint: 'D\'autres travaux peuvent être chargés ci-dessous.',
    id:             'ID du travail',
    printer:        'Imprimante',
    register:       'Caisse',
    status:         'Statut',
    createdAt:      'Créé le',
    updatedAt:      'Dernière mise à jour',
    payload:        'Charge utile',
    create:         'Créer un travail d\'impression',
    send:           'Envoyer le travail d\'impression',
    sending:        'Création en cours …',
    selectRegister: 'Sélectionner une caisse …',
    payloadLabel:   'JSON Payload (format Payfix)',
    loadExample:    'Charger un exemple',
    invalidJson:    'JSON invalide. Veuillez vérifier.',
    created:        'Travail d\'impression créé',
    sourcePayfix:   'Payfix',
    sourceDashboard:'Tableau de bord',
    source:          'Source',
    type:            'Type',
    typePrintjobs:   'Travaux d\'impression',
    typeReceipts:    'Reçus',
    statusAll:       'Tous',
    allPrinters:     'Toutes les imprimantes',
    allPrintservers: 'Tous les serveurs d\'impression',
    cashier:         'Employé',
    positions:       'Postes',
    total:           'Total',
    received:        'Reçu',
    printed:         'Imprimé',
    paymentMethod:   'Mode de paiement',
    items:           'Art.',
    posName:         'Article',
    posQty:          'Quantité',
    posUnit:         'Prix unitaire',
    posTotal:        'Total',
    subtotal:        'Sous-total',
    tax:             'TVA',
    noItems:         'Aucun poste disponible.',
    resend:          'Renvoyer',
    deleteTitle:     'Supprimer le travail d\'impression ?',
    deleteConfirm:   'Voulez-vous vraiment supprimer le travail {id} ?',
    loadMore:          'Charger plus de travaux',
    loadingMore:       'Chargement …',
    loadedCount:       '{count} travaux chargés',
    endOfList:         'Fin de la liste – tous les travaux sont chargés.',
    loadMoreError:     'Échec du chargement.',
    liveFirstPageOnly: 'Seule la première page est actualisée en direct.',
    device:          'Appareil',
    deleteError:     'Échec de la suppression.',
    resendError:     'Le renvoi a échoué. Le travail n\'a pas été créé.',
    resendNoPrintserver: 'Renvoi impossible : aucun serveur d\'impression n\'est attribué à ce canal (les canaux d\'écran ne peuvent pas être imprimés).',
    deliveryStatus:  'Statut de livraison',
    printerName: {
      idHint:         'Identifiant de l\'imprimante : {id}',
      unresolved:     'Nom introuvable',
      unresolvedHint: 'Aucun canal ne correspond à cet identifiant dans la liste chargée – il a probablement été supprimé. Identifiant : {id}',
      notLoaded:      'Nom non chargé',
      notLoadedHint:  'La liste des imprimantes n\'est chargée que page par page, le nom de ce canal n\'y figure donc pas encore. Cela ne dit pas si le canal existe encore – chargez d\'autres imprimantes. Identifiant : {id}',
    },
    workStatus: {
      label:              'Statut de traitement',
      columnHint:         'Deuxième dimension de statut, indépendante : seules les commandes (bons de préparation) portent un statut de traitement. Les tickets de caisse n\'en portent pas, leur champ reste donc vide. Il n\'est affiché que pour les canaux dont la vue Kitchen TV est activée ; sur toutes les autres lignes, le champ reste également vide — dans le détail de la tâche, la valeur y demeure visible dès qu\'elle diffère de « Ouvert ».',
      open:               'Ouvert',
      inPreparation:      'En préparation',
      ready:              'Prêt à être retiré',
      done:               'Terminé',
      unknown:            'Inconnu',
      unknownHint:        'Cette valeur ne fait pas partie du vocabulaire prévu.',
      notPrintedDoneHint: 'Pas de contradiction : la livraison et le traitement sont deux indications distinctes. Le travail n\'a jamais atteint sa destination, mais il a été clôturé sur le plan opérationnel (automatiquement après quatre heures).',
      readOnly:           'Affichage seul – le statut de traitement n\'est pas modifié ici.',
    },
    // Omission consignée sur le ticket (REQ-PR-037, complément REQ-DM-030,
    // T-M11.12).
    omitted: {
      badge:       'Ticket incomplet',
      badgeHint:   'Le travail a été livré, mais le modèle d\'imprimante n\'a pas pu exécuter certaines commandes du ticket. Le détail déplié indique ce qui a été omis.',
      title:       'Commandes non exécutées',
      position:    'Position',
      opcode:      'Opcode',
      opcodeNone:  'aucune commande précise',
      reasonLabel: 'Motif',
      unknownHint: 'Cette valeur ne fait pas partie du vocabulaire prévu.',
      reason: {
        unsupportedByModel: 'Non pris en charge par le modèle d\'imprimante',
        emptyPayload:       'Aucune donnée utile',
        invalidParameter:   'Paramètre non valide',
        unflushedBuffer:    'Tampon de ligne non émis',
        unknownOpcode:      'Commande d\'impression inconnue',
        logoUnreadable:     'Logo non imprimable',
        unknown:            'Inconnu',
      },
      detail: {
        cut:      'Coupe complète',
        textline: 'Tampon de ligne',
        unknown:  'Inconnu',
      },
    },
    deliveredWithoutPrint: {
      badge:     'Livré sans impression',
      badgeHint: 'Ce travail n\'a volontairement pas été imprimé : le canal affiche les bons de préparation uniquement à l\'écran. Il est considéré comme livré dès sa réception et ne porte donc aucune heure d\'impression.',
      title:     'Livré sans impression',
      timeLabel: 'Livré (sans impression)',
    },
    deliveryConfirmation: {
      badge:     'Livré sans confirmation de l\'imprimante',
      badgeHint: 'Ce modèle d\'imprimante ne confirme pas l\'impression ; seule la transmission a été mesurée.',
    },
    // Aperçu du contenu du ticket (REQ-OPS-060, T-M29.3) — en lecture seule et
    // expressément PAS un aperçu d'impression. Aucune commande n'est omise en
    // silence (REQ-PR-020).
    belegVorschau: {
      title:               'Contenu du ticket (aperçu)',
      abweichungsHinweis:  'Ce n\'est pas un aperçu d\'impression : le ticket imprimé peut en différer. La largeur des lignes, la taille du texte et les images ne sont créées que dans l\'imprimante.',
      u220Hinweis:         'Ce ticket utilise le langage de commandes du TM-U220. Aucun aperçu n\'existe pour celui-ci — les mêmes numéros de commande y ont une autre signification, un affichage serait deviné au lieu d\'être lu.',
      leerHinweis:         'Ce ticket ne contient aucune commande d\'impression.',
      platzhalter: {
        align:           'Alignement',
        textSize:        'Taille du texte',
        cut:             'Coupe',
        qr:              'Code QR',
        image:           'Image',
        textEmpty:       'Commande de texte sans contenu',
        unknown:         'Commande inconnue {opcode} à la position {position}',
        unknownNoOpcode: 'Commande sans numéro à la position {position}',
      },
    },
  },

  settings: {
    title: 'Paramètres',

    company: {
      title:            'Entreprises',
      subtitle:         'Toutes les entreprises enregistrées',
      eyebrow:          'Paramètres · Entreprise',
      add:              'Ajouter une entreprise',
      empty:            'Aucune entreprise créée.',
      name:             'Nom de l\'entreprise',
      nameLabel:        'Nom de l\'entreprise *',
      email:            'E-mail',
      phone:            'Téléphone',
      address:          'Adresse',
      city:             'Ville',
      zip:              'Code postal',
      country:          'Pays',
      logo:             'Logo',
      description:      'Description',
      descriptionHint:  'Notes internes …',
      companyData:      'Données de l\'entreprise',
      bonSettings:      'Paramètres du bon',
      bonLogo:          'Logo du bon',
      bonLogoHint:      'Apparaît en haut du reçu client et du reçu d\'annulation, sur la note intermédiaire selon le commutateur ci-dessous, pas sur les clôtures et pas sur les imprimantes TM-U220. PNG, JPG ou SVG, max. 2 Mo ; réduit à la largeur d\'impression et imprimé en noir et blanc.',
      bonLogoDrop:      'Déposez ou sélectionnez le logo ici',
      // T-M51.4 (REQ-DM-010a Praez. 1 (2)/(4)): Meldungen der Logo-Erfassung,
      // die Beschriftung der Druckvorschau und der Hinweis unter Schlusstext
      // und QR-Code-URL.
      bonLogoFileTooLarge:   'Le fichier dépasse 2 Mo.',
      bonLogoResultTooLarge: 'Même réduit, le logo est trop volumineux pour être enregistré. Veuillez choisir un fichier plus simple.',
      bonLogoNotImage:       'Le fichier n\'a pas pu être lu comme image.',
      bonLogoPrintPreview:   'Aperçu d\'impression (noir et blanc)',
      bonFooterQrHint:       'Apparaissent à la fin du reçu client, sur la note intermédiaire selon les commutateurs ci-dessous, pas sur les reçus d\'annulation ni les clôtures, et pas sur les imprimantes TM-U220.',
      // T-M54.5 (REQ-DM-010a Praez. 2 (4)): Kartenueberschrift und die drei
      // Schalter der Zwischenrechnung mit ihrem Hinweis.
      receiptSettings:       'Paramètres des reçus',
      interimReceiptLogo:    'Imprimer le logo sur la note intermédiaire',
      interimReceiptFooter:  'Imprimer le texte de fin sur la note intermédiaire',
      interimReceiptQr:      'Imprimer le QR code sur la note intermédiaire',
      interimReceiptHint:    'S\'applique à la note intermédiaire de la caisse, sur les imprimantes Epson et Sunmi, pas sur les imprimantes TM-U220. Ce qui n\'est pas saisi ci-dessus n\'est pas non plus imprimé sur la note intermédiaire.',
      bonFooter:        'Pied de page du bon',
      qrUrl:            'URL du QR code',
      usersSection:     'Utilisateurs',
      usersSubtitle:    'Utilisateurs de cette entreprise et leurs droits de modification',
      addUser:          'Ajouter un utilisateur',
      noUsers:          'Aucun utilisateur assigné',
      userCol:          'Utilisateur',
      emailCol:         'E-mail',
      removeUser:       'Retirer l\'utilisateur ?',
      removeUserConfirm:'Voulez-vous vraiment retirer cet utilisateur de l\'entreprise ?',
      existingUser:     'Utilisateur existant',
      inviteByEmail:    'Inviter par e-mail',
      userSearch:       'Rechercher un utilisateur …',
      noUsersFound:     'Aucun utilisateur trouvé',
      inviteSent:       'Invitation envoyée à {email} !',
      inviteEmailHint:  'L\'utilisateur reçoit un e-mail avec un lien pour définir son mot de passe.',
      systemRole:       'Rôle système',
      roleUser:         'Utilisateur',
      roleAdmin:        'Administrateur',
      deleteTitle:      'Supprimer l\'entreprise ?',
      deleteConfirm:    'Voulez-vous vraiment supprimer {name} ?',
      cannotUndoFull:   'Voulez-vous vraiment supprimer « {name} » ? Cette action est irréversible.',
      payfixId:         'ID client Payfix',
      payfixIdHint:     'Attribué par Payfix et non modifiable.',
      receiptFooter:    'Texte de fin du reçu',
      footerPlaceholder:'Merci de votre achat !',
      alarmCenter:      'Centre d\'alarme',
      alarmSectionSub:  'Notifications automatiques en cas de problème',
      emailAlarm:       'Alarme e-mail',
      emailAlarmHint:   'Notifications par e-mail',
      alarmWhen:        'Quand faut-il alarmer ?',
      triggerQueueOffline:      'File d\'attente hors ligne',
      triggerQueueOfflineDesc:  'Notification lorsque la file d\'attente du serveur d\'impression passe hors ligne',
      triggerNotPrinted:        'Travail d\'impression non imprimé (10 min)',
      triggerNotPrintedDesc:    'Notification lorsqu\'un bon n\'a pas encore été imprimé après 10 minutes',
      triggerPrinterOffline:    'Panne d\'imprimante',
      // `alarmOnPrinterOffline` traegt ALLE Drucker-Stufen, nicht nur `offline`
      // (T-M42.10); bis zum 2026-09-26 lautete der Text „Drucker Offline“.
      triggerPrinterOfflineDesc:'Notification pour chaque niveau d\'alarme activé sur l\'imprimante (hors ligne, erreur, papier presque vide, capot ouvert, plus de papier)',
      // T-M42.10 Teil (b): Alarmierung nicht eingerichtet (utils/alarmEinrichtung.ts).
      alarmNotSetUp:             'Alarmes non configurées',
      alarmNotSetUpNoType:       'Aucun type d\'alarme n\'est activé. Aucune alarme n\'est actuellement envoyée pour cette entreprise.',
      alarmNotSetUpNoRecipients: 'Aucun destinataire n\'est défini : activez l\'alarme par e-mail et saisissez au moins une adresse. D\'ici là, aucune alarme n\'est envoyée pour cette entreprise.',
      alarmNotSetUpSavedState:   'C\'est l\'état enregistré qui fait foi.',
    },

    users: {
      title:           'Utilisateurs',
      subtitle:        'Tous les utilisateurs de cette entreprise',
      eyebrow:         'Paramètres · Utilisateurs',
      add:             'Inviter un utilisateur',
      empty:           'Aucun utilisateur disponible.',
      searchEmpty:     'Aucun utilisateur trouvé pour «{search}».',
      name:            'Nom',
      email:           'E-mail',
      role:            'Rôle',
      status:          'Statut',
      lastLogin:       'Dernière connexion',
      data:            'Données utilisateur',
      emailHint:       'L\'e-mail ne peut pas être modifié après la création.',
      inviteHint:      'L\'utilisateur reçoit un e-mail d\'invitation pour définir son mot de passe.',
      roleAccess:      'Rôle & Accès',
      internalNote:    'Note interne',
      internalNotePH:  'Responsabilités, département …',
      noAccount:       'Aucun compte de connexion',
      noAccountHint:   'Cet utilisateur a été créé sans Firebase Auth et ne peut pas se connecter. Envoyez un e-mail d\'invitation pour corriger cela.',
      inviteSent:      'Invitation envoyée !',
      inviteSentHint:  'Un e-mail a été envoyé à {email}. L\'utilisateur peut ainsi définir son mot de passe.',
      deleteTitle:     'Supprimer l\'utilisateur ?',
      deleteConfirm:   'Voulez-vous vraiment supprimer « {name} » ? L\'utilisateur perd immédiatement l\'accès.',
      invite:          'Envoyer l\'invitation',
      invited:         'Invité',
      companies:       'Entreprises',
      companiesHint:   'L\'utilisateur voit et gère les données de ces entreprises.',
      // Pour le rôle `admin`, cette indication remplace la liste de cases
      // (REQ-SEC-030 préc. 1 (c), REQ-SEC-027 (a) — T-M38.4).
      companiesAdminHint: 'Les administrateurs ont accès à toutes les entreprises; aucune attribution n\'est nécessaire.',
      companiesNone:   'Aucune entreprise attribuée pour l\'instant.',
      companySearch:   'Rechercher une entreprise …',
      companyNoMatch:  'Aucune entreprise trouvée.',
      companyLimit:    'Un utilisateur peut avoir au maximum {max} entreprises. Veuillez d\'abord en retirer une.',
      companyRequired: 'Veuillez sélectionner au moins une entreprise pour l\'invitation.',
      invitations:     'Invitations en attente',
      openInvitation:  'Invitation en attente',
      validUntil:      'Valable jusqu\'au {date}',
      expiredOn:       'Expirée le {date}',
      reinvite:        'Inviter à nouveau',
      inviteFailed:    'L\'invitation n\'a pas pu être envoyée.',
    },

    smtp: {
      title:            'E-mail SMTP',
      subtitle:         'Paramètres d\'envoi d\'e-mails',
      infoText:         'Ces paramètres SMTP sont destinés aux e-mails personnalisés. Firebase Auth envoie les e-mails système indépendamment.',
      serverConnection: 'Connexion au serveur',
      authentication:   'Authentification',
      sender:           'Expéditeur',
      statusCard:       'Statut',
      encryption:       'Chiffrement',
      lastSaved:        'Dernière sauvegarde',
      testSentTo:       'E-mail de test envoyé à {email} !',
      host:             'Hôte SMTP',
      port:             'Port',
      user:             'Nom d\'utilisateur',
      password:         'Mot de passe',
      fromEmail:        'E-mail expéditeur',
      fromName:         'Nom de l\'expéditeur',
      secure:           'Utiliser SSL / TLS',
      test:             'Envoyer un e-mail de test',
      testSent:         'E-mail de test envoyé avec succès !',
      save:             'Enregistrer les paramètres SMTP',
      noEncryption:     'Aucun chiffrement (Port 25)',
      starttls:         'STARTTLS (Port 587)',
      tls:              'SSL/TLS (Port 465)',
      activeLabel:      'SMTP actif',
      activeNotice:     'Les e-mails d\'invitation et les notifications système sont envoyés via cette configuration SMTP.',
      activeFallback:   'Si le SMTP n\'est pas configuré, Firebase Authentication est utilisé automatiquement comme solution de repli.',
      secretBadge:      'Enregistré comme secret Firebase',
      secretHint:       'Ce secret ne se trouve pas dans la base de données et n’est jamais chargé dans le navigateur. Il est défini côté serveur dans le projet Firebase avec la commande ci-dessous. Saisissez la valeur à l’invite ou transmettez-la par un pipe avec printf %s, jamais avec echo : echo ajoute un saut de ligne, qui est repris tel quel dans le secret.',
    },

    api: {
      eyebrow:          'Paramètres · API',
      title:            'Tokens API',
      subtitle:         'Tokens d\'accès pour l\'API REST publique',
      tokensTitle:      'Tokens API',
      tokensSubtitle:   'Tokens pour l\'accès API externe — de cette entreprise et globaux',
      generate:         'Générer un token',
      noCompany:        'Veuillez d\'abord sélectionner une entreprise.',
      empty:            'Aucun token API pour le moment.',
      colScope:         'Portée',
      scopeGlobal:      'Global',
      scopeCompany:     'Entreprise',
      scopeGlobalHint:  'Valable pour toutes les entreprises.',
      scopeCompanyHint: 'Valable uniquement pour cette entreprise.',
      globalLabel:      'Token global',
      globalHint:       'Valable pour toutes les entreprises au lieu de cette seule entreprise. À utiliser uniquement pour les accès internes et à nommer de façon à identifier son utilisateur.',
      revokeGlobalHint: 'Ce token est valable pour toutes les entreprises. Après la révocation, toutes les entreprises perdent immédiatement l\'accès par ce biais.',
      colName:          'Nom',
      colPrefix:        'Préfixe',
      colStatus:        'Statut',
      colCreated:       'Créé',
      colExpires:       'Valable jusqu\'au',
      colLastUsed:      'Dernière utilisation',
      statusActive:     'Actif',
      statusRevoked:    'Révoqué',
      neverExpires:     'Illimité',
      revoke:           'Révoquer le token',
      tokenCreated:     'Token généré – sauvegardez-le maintenant !',
      tokenOnceHint:    'Le token n\'est affiché qu\'une seule fois. Copiez-le en lieu sûr.',
      connectionTitle:  'Connexion',
      authLabel:        'Authentification',
      contentTypeLabel: 'Content-Type',
      connectionNote:   'Transmettez le token à chaque requête dans l\'en-tête Authorization comme Bearer token.',
      createTitle:      'Générer un nouveau token API',
      createBody:       'Attribuez éventuellement un nom et une date d\'expiration.',
      nameLabel:        'Nom (facultatif)',
      namePlaceholder:  'p. ex. Intégration Payfix',
      expiresLabel:     'Date d\'expiration (facultative)',
      expiresHint:      'Laisser vide pour un token illimité.',
      revokeTitle:      'Révoquer le token ?',
      revokeBody:       'Le token « {name} » sera révoqué de manière irréversible. Toutes les intégrations qui l\'utilisent perdront immédiatement l\'accès.',
      revokeConfirm:    'Oui, révoquer',
    },
  },

  companySelect: {
    title:    'Sélectionner une entreprise',
    subtitle: 'Veuillez sélectionner une entreprise pour continuer.',
    search:   'Rechercher une entreprise …',
    empty:    'Aucune entreprise trouvée.',
    continue: 'Continuer',
    notFound: 'Aucune entreprise trouvée pour « {query} »',
    // ⚠ ENTFALLEN AM 2026-08-22 (T-M24.3, REQ-OPS-058 (2)) — die vier Saetze
    // der Nachlade-Leiste (`limitReached`, `loadMore`, `loadedCount`,
    // `endOfList`) sind in allen sechs Sprachen zurueckgenommen; der deutsche
    // Wortlaut steht in `de.ts`. Die Firmen-Auswahl laedt alle Firmen auf
    // einmal. Die gleichnamigen Saetze unter `printers.*` bleiben stehen.
  },

  location: {
    offline: 'Site hors ligne',
  },

  fastline: {
    cameraOpen:    'Ouvrir la caméra',
    orderNumber:   'Numéro de commande',
    search:        'Rechercher',
    scan:          'Scanner',
    scanQr:        'Scanner le code QR',
    // Le pavé tactile de la saisie manuelle (REQ-SC-099, T-M23.3).
    keypadOpen:      'Saisir le code',
    keypadTitle:     'Saisir le code manuellement',
    keypadHint:      'Solution de repli lorsque le code QR est illisible. Le scanner et la caméra restent la voie normale.',
    keypadSearch:    'Rechercher la commande',
    keypadBackspace: 'Effacer le dernier caractère',
    // Les deux écrans de résultat (REQ-SC-100, T-M23.4).
    pickedUpTitle:     'Retirée',
    pickedUpDone:      'La commande est clôturée et retirée de la liste.',
    pickedUpAutoClose: 'Cette fenêtre se ferme d\'elle-même dans {seconds} secondes.',
    notFoundTitle:     'Commande introuvable',
    notFoundText:      'Ce code est inconnu.',
    notFoundRescan:    'Scanner à nouveau',
    notFoundManual:    'Saisir le code manuellement',
    scanHint:      'Placez le code QR dans le cadre',
    // Retour du scan déplacé vers `screen.*` avec T-M12.21 (REQ-SC-082).

    // L'unique action principale de la fenêtre de retrait (REQ-SC-098 (4)).
    pickUp:        'Retirer',
    scannerReady:     'Scanner prêt',
    scannerReadyHint: 'Scannez le code QR du ticket — la commande s\'ouvre d\'elle-même.',
  },

  kitchen: {
    toCook:           'À cuisiner',
    tickets:          'Tickets',
    allDone:          'Tout est terminé',
    openItems:        'Articles ouverts',
    open:             'Ouvert',
    inProgress:       'En cours',
    start:            'Démarrer',
    markReady:        'Prêt à retirer',
    done:             'Terminé',
    emptyOpen:        'Aucune commande ouverte',
    emptyInProgress:  'Aucune commande en cours',
    emptyReady:       'Aucune commande prête à retirer',
    emptyOrders:      'Aucune commande',
    doneAll:          'Tout est prêt !',
    actionFailed:     'Non enregistré. Veuillez appuyer à nouveau.',
    actionStale:      'La commande a changé. L’affichage se met à jour tout seul.',
    actionExpired:    'La session de cet écran a expiré. Veuillez recharger la page.',
    // Regroupement et démarrage par service (REQ-SC-068, T-M12.8). L’identifiant
    // du service est une CHAÎNE reprise telle quelle — `Service 2`, aussi `Service Ürli`.
    gangLabel:        'Service {gang}',
    startGang:        'Démarrer le service',
    // Artikel-Countdown (REQ-SC-071): Aufschrift der Startschaltflaeche.
    timerStart:       '{minutes} min',
    // Modifications ultérieures (REQ-SC-072, T-M12.7) : libellé du bouton
    // rouge lorsque la quantité résultante tombe à zéro ou en dessous.
    fullyCancelled:   'Entièrement annulé',
    // Dialogue de résultat du scan de retrait (REQ-SC-073, T-M12.10). Le MOTIF
    // NOMMÉ de REQ-SC-087 se trouve depuis T-M12.54 sous `screen.scanNotReady` :
    // c'est la même phrase sur les trois vues.
    tableNumber:      'Table {number}',
    scanReceived:     'Réception',
    scanNoDetail:     'Les détails de cette commande ne sont pas disponibles sur cet écran.',
    // Statut de la carte dans la vue Fastline (REQ-SC-097 (2)) — affichage
    // seulement ; le statut de traitement reste `open` dans Firestore.
    waitingForPickupScan: 'En attente du scan de retrait',
  },

  screen: {
    keyPrompt:      'Saisir la clé d’affichage',
    keyPlaceholder: 'Clé d’affichage',
    connect:        'Connecter',
    connecting:     'Connexion en cours …',
    invalidKey:     'Clé d’affichage non valide.',
    notPrinted:     'Ticket pas encore imprimé',
    limitReached:   'Seules les {count} commandes les plus récentes sont affichées.',
    // Vue désactivée (REQ-SC-079, T-M12.19).
    viewDisabledTitle:       'Cette vue est désactivée',
    viewDisabledKitchenTv:   'La Kitchen TV n’est pas activée pour ce canal.',
    viewDisabledAbholscreen: 'L’écran de retrait n’est pas activé pour ce canal.',
    viewDisabledChannel:     'Canal : {name}',
    viewDisabledHelp:        'Vous pouvez activer la vue pour ce canal sous « Imprimantes » dans le tableau de bord.',
    // Reprise du mode d’écran (REQ-SC-104 (5), T-M25.3) — un seul mode est
    // actif par canal ; l’écran nouvellement ouvert nomme le mode actif et
    // n’écrit qu’après confirmation.
    modeNameNormal:   'Kitchen TV',
    modeNameLight:    'Kitchen TV Light',
    modeNameFastline: 'Fastline',
    takeoverTitle:    'Un autre mode est actif',
    takeoverWarning:  'Ce canal exécute actuellement « {active} ». Si vous démarrez « {own} » ici, « {active} » sera désactivé.',
    takeoverIdle:     'Cet écran n’a pas encore repris « {own} ».',
    takeoverConfirm:  'Démarrer « {own} » ici',
    takeoverRunning:  'Reprise en cours …',
    takeoverHint:     'Rien ne change tant que vous ne confirmez pas – l’autre écran continue de fonctionner.',
    // Retour du scan de retrait (REQ-SC-082, T-M12.21) — partagé par les trois écrans.
    alreadyPickedUp:       'Déjà retirée',
    alreadyPickedUpAt:     'Retirée le {time}',
    alreadyPickedUpNoTime: 'Heure non enregistrée',
    scanFound:             'Commande trouvée',
    scanCompleted:         'Terminé',
    scanNotFound:          'Aucune commande correspondante trouvée',
    scanError:             'Erreur de scan',
    scanNotReady:          'Le scan est enregistré. La clôture n\'a lieu qu\'à partir de « Prêt à être retiré ».',
    // Saisie et scan sur l’écran de retrait (REQ-SC-012, T-M12.23).
    pickupPrompt: 'Saisir ou scanner le numéro de commande',
    pickupNumber: 'Numéro de commande',
    pickupSubmit: 'Retirer',
    // Clôture groupée (REQ-SC-083, T-M12.22). La confirmation doit nommer ce
    // qui est clôturé et combien — et dire expressément que rien n’est imprimé.
    completeAll:        'Tout terminer',
    completeAllTitle:   'Terminer toutes les commandes ?',
    completeAllBody:    '{count} commandes en «En cours» et «Prêt à emporter» seront terminées. Il s’agit d’un nettoyage de l’affichage : rien n’est imprimé et aucun ticket n’est émis.',
    completeAllChunks:  'Il y a plus de {max} commandes. Elles sont terminées en {calls} étapes ; si une étape échoue, les commandes des étapes suivantes restent ouvertes.',
    completeAllConfirm: 'Oui, terminer {count}',
    completeAllDone:    '{count} commandes terminées.',
    completeAllNoScan:  'Non retirées avec un code QR : {count} commandes ne portent aucun scan de retrait. Terminer quand même ?',
    // Etiquette d'origine au canal Fast Line (REQ-SC-095). « OrderMood » est
    // un nom propre et reste identique dans toutes les langues.
    originOrderMood: 'OrderMood',
    originRegister:  'Caisse',
  },

  // ── Das Kennzeichen des Testsystems (T-M32.7, REQ-OPS-061) ────────────────
  // Der Streifen am oberen Rand der Verwaltungsoberflaeche. Uebersetzt wird
  // allein das WORT „Testsystem"; `{projektId}` ist ein technischer Name und
  // steht in jeder Sprache gleich (REQ-OV-002, REQ-OV-008).
  // Der Emulator-Wortlaut ist der Sonderfall des lokalen Entwicklungswegs: dort
  // lautet die Projekt-ID `printerque-prod`, weil sie beim Emulatorlauf nur die
  // Audience der ID-Token ist (REQ-OPS-064 (a)) — ohne den Zusatz stuende ein
  // Widerspruch auf dem Bildschirm.
  umgebung: {
    testBanner:         'SYSTÈME DE TEST · {projektId}',
    testBannerEmulator: 'SYSTÈME DE TEST · {projektId} · Émulateur',
  },
}
